/**
 * If true, renders a polygon representing the bounds of the labels for boundaries.
 * Useful for debugging label placement and visibility.
 */
export const DEBUG_LABEL_BOUNDS = false;

/**
 * If true, generates sample items in the Top Underbar.
 * Useful for testing different types of notifications/alerts in the UI.
 */
export const GENERATE_UNDERBAR_ITEM_SAMPLES = false;

/**
 * If true, sends the full geometry (multipolygon) instead of the boundary ID when requesting boundary metrics.
 * Useful for generating requests and curl scripts independent of the boundary ID
 */
export const DEBUG_SEND_GEOMETRY_INSTEAD_OF_BOUNDARY_ID = false;

/**
 * If true, renders a polygon representing the last bounds.
 * Useful for debugging map alignment and boundary issues.
 */
export const DEBUG_LAST_BOUNDS = false;
